export default __webpack_public_path__ + "static/media/book.ada2913d.png";